<template>
<div class="chapter">
<div class="inner_page">
<h1 class="worktitle">The Ugliest House in the World</h1>
<h2 class="worksubtitle">STORIES</h2>
<h2 class="workauthors">Peter Ho Davies</h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// titlepage.vue?8985f18e